import cn from 'classnames';
import { toPascalCase } from 'core-lib/utils/utils';
import { useRouter } from 'next/router';
import { ModelDetailType, VariantsListType } from 'src/modules/newCars/types';
import { trackVariantClicked } from 'src/modules/newCars/utils/events/variant';
import { Button, Typography } from 'ui';
import { ButtonVariants, Color, TypeScales } from 'ui/primitives';
import s from './FilterVariantListingCard.module.scss';
import { useSelector } from 'react-redux';
import { useNativeAuth } from 'auth/hooks/useNativeAuth';
import TestDrivePopup from '../../popups/TestDrivePopup';
import { getDefaultAttributes } from 'core-lib/utils/events/attributes';
import { trackEvent } from 'core-lib/utils/events';
import { useState } from 'react';

type VariantCardType = {
  variantDetail: VariantsListType;
  modelName: string;
  modelImage: string;
  onVariantClick?: () => void;
  link: string;
  modelId?: number;
};

export const FilterVariantListingCard = ({
  variantDetail,
  modelName,
  modelImage,
  onVariantClick,
  link,
  modelId = null,
}: VariantCardType) => {
  const [showDetailPopup, setShowDetailPopup] = useState(false);
  const router = useRouter();
  const { isAuthenticated } = useSelector((state: any) => state?.auth);
  const { login } = useNativeAuth();

  const checkAuth = async (callback) => {
    if (isAuthenticated) {
      callback();
    } else {
      const res = await login();
      if (res) {
        callback();
      }
    }
  };
  function handleVariantClick() {
    if (onVariantClick) onVariantClick();
    trackVariantClicked();
  }
  function handleVariantRedirect() {
    router.push(link);
    trackVariantClicked();
  }

  const handleBookClick = () => {
    checkAuth(() => {
      setShowDetailPopup(true);
    });
    trackEvent({
      name: 'cta_clicked',
      defaultAttr: getDefaultAttributes(),
      attributes: {
        category: 'Services',
        subcategory: 'Test Drive',
        cta_name: 'book test drive',
        page_name: 'new_cars_web',
      },
    });
  };

  return (
    <div className={s.variant} key={variantDetail?.variantName} aria-hidden>
      <div className={s.variantContent} onClick={handleVariantClick}>
        <div className={s.variantInfo}>
          <div className={s.part1}>
            <a
              href={link}
              style={{ pointerEvents: 'none' }}
              className={s.title}
            >
              <Typography
                label={`${variantDetail?.variantName}`}
                variant={TypeScales.h4}
                renderAs="SPAN"
              />
            </a>
            <div className={s.details}>
              <Typography
                label={toPascalCase(variantDetail?.fuelType)}
                color={Color.text_subheading}
                variant={TypeScales.body_para_r}
              />
              {variantDetail?.engine && <p className={s.dot} />}
              <Typography
                label={toPascalCase(variantDetail?.transmission)}
                color={Color.text_subheading}
                variant={TypeScales.body_para_r}
              />
              {variantDetail?.mileage && <p className={s.dot} />}
              <Typography
                label={variantDetail?.mileage}
                color={Color.text_subheading}
                variant={TypeScales.body_para_r}
              />
            </div>
          </div>
          <div className={s.part2}>
            <Button
              label="View details"
              variant={ButtonVariants.ButtonLink}
              size="Small"
              onClick={(e) => {
                e.stopPropagation();
                handleVariantRedirect();
              }}
            />
          </div>
        </div>
        <div className={s.priceInfo}>
          <div className={s.price_wrapper}>
            <Typography
              label={variantDetail?.price}
              variant={TypeScales.h4}
              className={s.price}
            />
            <Typography
              label="Starting price for new model"
              variant={TypeScales.small_m}
              color={Color.text_subheading}
              className={s.description}
            />
          </div>
          <div className={s.btn}>
            <Button
              label="Book Test Drive"
              onClick={(e) => {
                e.stopPropagation();
                handleBookClick();
              }}
            />
          </div>
        </div>
        {showDetailPopup && (
          <TestDrivePopup
            modelId={modelId}
            show={showDetailPopup}
            onClose={() => {
              setShowDetailPopup(false);
            }}
          />
        )}
      </div>
    </div>
  );
};
